import * as Actions from '../Actions/TagFuncionalidadeActions';
// import _ from '@lodash';

const initialState = {
    data: null,
    funcionalidades: null,
    fluxos: null,
    tagFuncionalidadeDialog: {
        type: 'new',
        props: {
            open: false,
            xappRouteParams: '',
            error: null,
            warning: null,
            info: null
        },
        data: null
    },
    error: null,
};

const TagFuncionalidadeReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_TAG_FUNCIONALIDADE:
            {
                return {
                    ...state,
                    data: action.payload,
                };
            }
        case Actions.GETCUSTOM_TAG_FUNCIONALIDADE:
            {
                return {
                    ...state,
                    [action.Name]: action.payload,
                };
            }
        case Actions.OPEN_NEW_TAG_FUNCIONALIDADE_DIALOG:
            {
                return {
                    ...state,
                    tagFuncionalidadeDialog: {
                        type: 'new',
                        props: {
                            open: true,
                            xappRouteParams: action.xappRouteParams
                        },
                        data: null
                    }
                };
            }
        case Actions.CLOSE_NEW_TAG_FUNCIONALIDADE_DIALOG:
            {
                return {
                    ...state,
                    tagFuncionalidadeDialog: {
                        type: 'new',
                        props: {
                            open: false
                        },
                        data: null
                    }
                };
            }
        case Actions.OPEN_EDIT_TAG_FUNCIONALIDADE_DIALOG:
            {
                return {
                    ...state,
                    tagFuncionalidadeDialog: {
                        type: 'edit',
                        props: {
                            open: true,
                            xappRouteParams: action.xappRouteParams

                        },
                        data: action.data
                    }
                };
            }
        case Actions.CLOSE_EDIT_TAG_FUNCIONALIDADE_DIALOG:
            {
                return {
                    ...state,
                    tagFuncionalidadeDialog: {
                        type: 'edit',
                        props: {
                            open: false
                        },
                        data: null
                    }
                };
            }
        case Actions.TAG_FUNCIONALIDADE_ERROR:
            {
                return {
                    ...state,
                    success: false,
                    tagFuncionalidadeDialog: {
                        type: 'edit',
                        props:
                        {
                            open: true,
                            error: action.payload
                        },
                        data: null
                    }
                };
            }
        case Actions.TAG_FUNCIONALIDADE_INFO:
            {
                return {
                    ...state,
                    success: true,
                    tagFuncionalidadeDialog: {
                        type: 'edit',
                        props:
                        {
                            open: false,
                            info: action.payload,
                            id: action.id
                        },
                        data: null
                    }
                };
            }
        case Actions.TAG_FUNCIONALIDADE_WARNING:
            {
                return {
                    ...state,
                    success: true,
                    tagFuncionalidadeDialog: {
                        props:
                        {
                            open: false,
                            warning: action.payload
                        },
                        data: null
                    }
                };
            }
        case Actions.TAG_FUNCIONALIDADE_SELECIONAR_ERROR:
            {
                return {
                    ...state,
                    success: false,
                    error: action.payload
                };
            }
        case Actions.TAG_FUNCIONALIDADE_SELECIONAR_INFO:
            {
                return {
                    ...state,
                    success: true,
                    tagFuncionalidadeDialog: {
                        type: 'edit',
                        props:
                        {
                            open: false,
                            info: action.payload,
                            id: action.id
                        },
                        data: null
                    }
                };
            }
        case Actions.TAG_FUNCIONALIDADE_SELECIONAR_WARNING:
            {
                return {
                    ...state,
                    success: true,
                    tagFuncionalidadeDialog: {
                        props:
                        {
                            open: false,
                            warning: action.payload
                        },
                        data: null
                    }
                };
            }
        case Actions.GET_FUNCIONALIDADE_INDEX:
            {
                return {
                    ...state,
                    funcionalidades: action.payload,
                };
            }
        case Actions.GET_FLUXOS_INDEX:
            {
                return {
                    ...state,
                    fluxos: action.payload,
                };
            }
        default:
            {
                return state;
            }
    }
};

export default TagFuncionalidadeReducer;

